export const SWIPE_UNLOCK_SCROLL_THRESHOLD_PX = 8;
export const SWIPE_UNLOCK_SCROLL_TOGGLE_COOLDOWN_MS = 100;

export type SwipeUnlockScrollIntent = "hide" | "show";

/**
 * Chrome-mobile-style scroll intent for the swipe-to-unlock bar.
 * Scroll down → hide; scroll up or at top → show.
 *
 * Uses hysteresis: once hidden, small upward bounce/momentum noise does not
 * re-show the bar — only a deliberate upward scroll past the threshold does.
 */
export function resolveSwipeUnlockScrollIntent(
  previousScrollY: number,
  currentScrollY: number,
  currentlyHidden: boolean,
  threshold = SWIPE_UNLOCK_SCROLL_THRESHOLD_PX,
): SwipeUnlockScrollIntent | null {
  if (currentScrollY <= 0) {
    return "show";
  }

  const delta = currentScrollY - previousScrollY;
  if (Math.abs(delta) < threshold) {
    return null;
  }

  if (currentlyHidden) {
    return delta < 0 ? "show" : null;
  }

  return delta > 0 ? "hide" : null;
}

export function shouldApplySwipeUnlockScrollIntent(
  currentHidden: boolean,
  intent: SwipeUnlockScrollIntent,
  lastIntent: SwipeUnlockScrollIntent | null,
  lastToggleAtMs: number,
  nowMs: number,
  cooldownMs = SWIPE_UNLOCK_SCROLL_TOGGLE_COOLDOWN_MS,
): boolean {
  const nextHidden = intent === "hide";
  if (nextHidden === currentHidden) {
    return false;
  }

  if (lastIntent !== null && lastIntent !== intent && nowMs - lastToggleAtMs < cooldownMs) {
    return false;
  }

  return true;
}
